var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fact-container"},[_c('div',{attrs:{"id":"factoid"}},[_c('bandwidth-svg'),_c('video-svg'),_c('latency-svg')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }